import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ContactBGSModal = styled.div``;
const Description = styled(Typography)`
  margin-bottom: 16px;
  text-align: center;
`;
const ExtraDescription = styled(Typography)`
  margin-bottom: 24px;
  text-align: center;
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export { ContactBGSModal, Description, ExtraDescription, ImageContainer };
